import React, { Fragment, memo, useState } from "react";

import Icon from "../../assets/icons/Icon";
import { createBadla } from "../../helper/common";
import { API_DELETE_SCRIPTS } from "../../utils/api/ApiConstant";

const BadlaRateTable = ({
  instrumentData = [],
  handleBadlaOrder,
  handleInformation,
  handlePostRequest,
}) => {
  const [actions, setActions] = useState({
    setting: [],
    isOpen: [],
  });

  return (
    <div className="market_body_main">
      {instrumentData && instrumentData.length ? (
        instrumentData.map((inst, i) => (
          <div className="rate_live" key={i}>
            <div className="market_card_hading">
              <h6>
                <Icon name="ChevronUp" className="icon_font text_up" />
                {inst?.settingName}
              </h6>
              <div className="icon_box">
                <button
                  type="button"
                  className="btn menu_icon"
                  onClick={() =>
                    setActions((prev) => ({
                      ...prev,
                      setting: prev.setting.includes(inst?._id)
                        ? prev.setting.filter((id) => id !== inst?._id) // Remove if exists
                        : [...prev.setting, inst?._id], // Add if not exists
                    }))
                  }
                >
                  <Icon name="EllipsisVertical" />
                </button>
                <button
                  type="button"
                  className="btn btn-secondary expand-add  btn-sm"
                  title="View"
                  onClick={() =>
                    setActions((prev) => ({
                      ...prev,
                      isOpen: prev.isOpen.includes(inst?._id)
                        ? prev.isOpen.filter((id) => id !== inst?._id) // Remove if exists
                        : [...prev.isOpen, inst?._id], // Add if not exists
                    }))
                  }
                >
                  <Icon name="ChevronDown" />
                </button>
              </div>
            </div>
            <div
              className="dropdown_menu"
              style={{
                display: `${
                  actions.setting.some((x) => x === inst?._id)
                    ? "block"
                    : "none"
                }`,
              }}
            >
              <button
                type="button"
                title="add"
                className="btn plus_icon"
                data-bs-toggle="modal"
                data-bs-target="#exampleAdd"
                onClick={() => handleBadlaOrder({ rowData: inst })}
              >
                <Icon name="PlusCircle" /> Add
              </button>
              <button
                type="button"
                title="Instrument"
                className=" btn exclamation_icon"
                data-bs-toggle="modal"
                data-bs-target="#exampleExclamation"
                onClick={() => handleInformation({ rowData: inst })}
              >
                <Icon name="AlertCircle" />
                Instrument
              </button>

              <button
                type="button"
                className="btn close_icon"
                onClick={() =>
                  handlePostRequest({
                    url: API_DELETE_SCRIPTS,
                    payload: { scriptId: inst?._id },
                    rowData: inst,
                    isDeleted: true,
                    toast: false,
                  })
                }
              >
                <Icon name="X" />
                delete
              </button>
            </div>
            <div className="market_card_name">
              <div className="market_font">
                <p>
                  Badla[BUY]
                  <span className="text_up">
                    {
                      createBadla({
                        rowData: inst,
                        index: 2,
                        key: "buy_price_0",
                        buySell: 1,
                      }).finalPrice
                    }
                  </span>
                </p>
                <p>
                  Badla[SELL]
                  <span className="text_down">
                    {
                      createBadla({
                        rowData: inst,
                        index: 2,
                        key: "sell_price_0",
                        buySell: 0,
                      }).finalPrice
                    }
                  </span>
                </p>
                <p>
                  Badla[LTP]
                  <span className="text_up">
                    {
                      createBadla({
                        rowData: inst,
                        index: 2,
                        key: "last_price",
                        buySell: null,
                      }).finalPrice
                    }
                  </span>
                </p>
              </div>
              <div
                className="market_position market_hide"
                style={{
                  display: `${
                    actions.isOpen.some((x) => x === inst?._id)
                      ? "block"
                      : "none"
                  }`,
                }}
              >
                <div className="market_order_box ">
                  <div className="text-box">
                    <p>NMCX BID</p>
                    <span>Comex (INR)</span>
                  </div>
                  <div
                    className="order_card "
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <p>{inst?.instrumentsDetail?.[0]?.buy_price_0}</p>
                    <span>
                      H :{" "}
                      {
                        createBadla({
                          rowData: inst,
                          index: 2,
                          key: "buy_price_0",
                          buySell: 1,
                        }).finalEqu
                      }
                    </span>
                  </div>
                </div>
                <div className="market_order_box ">
                  <div className="text-box">
                    <p>MCX ASK</p>
                    <span>Comex (INR)</span>
                  </div>
                  <div
                    className="order_card "
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <p>{inst?.instrumentsDetail?.[0]?.sell_price_0}</p>
                    <span>L : 22,826.25</span>
                  </div>
                </div>
              </div>
              <div
                className="market_position market_hide"
                style={{
                  display: `${
                    actions.isOpen.some((x) => x === inst?._id)
                      ? "block"
                      : "none"
                  }`,
                }}
              >
                <div className="market_order_box ">
                  <div className="text-box">
                    <p>COMEX BID</p>
                  </div>
                  <div
                    className="order_card "
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <p>{inst?.instrumentsDetail?.[1]?.buy_price_0}</p>
                  </div>
                </div>
                <div className="market_order_box ">
                  <div className="text-box">
                    <p>COMEX ASK</p>
                  </div>
                  <div
                    className="order_card"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <p>{inst?.instrumentsDetail?.[1]?.sell_price_0}</p>
                  </div>
                </div>
              </div>
              <div
                className="market_position market_hide"
                style={{
                  display: `${
                    actions.isOpen.some((x) => x === inst?._id)
                      ? "block"
                      : "none"
                  }`,
                }}
              >
                <div className="market_order_box ">
                  <div className="text-box">
                    <p>DGCX BID</p>
                  </div>
                  <div className="order_card ">
                    <p>{inst?.instrumentsDetail?.[2]?.buy_price_0}</p>
                    <span>
                      {(
                        10000 / inst?.instrumentsDetail?.[2]?.buy_price_0
                      ).toFixed(2)}
                    </span>
                  </div>
                </div>
                <div className="market_order_box ">
                  <div className="text-box">
                    <p>DGCX ASK</p>
                  </div>
                  <div className="order_card ">
                    <p>{inst?.instrumentsDetail?.[2]?.sell_price_0}</p>
                    <span>
                      {(
                        10000 / inst?.instrumentsDetail?.[2]?.sell_price_0
                      ).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <>No Record</>
      )}
    </div>
  );
};

export default memo(BadlaRateTable);
